module.exports = __webpack_public_path__ + "img/mlm.1ab27ee2.svg";